// extracted by mini-css-extract-plugin
module.exports = {"blue":"#4185f4","white":"#FFFF","black":"#000"};